import React from 'react';
import Page1 from "./Page1";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page4 from "./Page4";
import Page5 from "./Page5";
import Page6 from "./Page6";
import Page7 from "./Page7";
import Page8 from "./Page8";
import Page9 from "./Page9";
import Page10 from "./Page10";
import {scrollToTop} from "../../../../../../libs/helpers";

export default class HowToWinAndManageResources extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 'Page1',
            pageData: props.pagesData?.['HowToWinAndManageResources']?.data || null
        };
    }

    pages = {
        Page1: Page1,
        Page2: Page2,
        Page3: Page3,
        Page4: Page4,
        Page5: Page5,
        Page6: Page6,
        Page7: Page7,
        Page8: Page8,
        Page9: Page9,
        Page10: Page10
    }

    handleChangePage = (currentPage) => _ => {
        this.setState({
            currentPage
        });

        scrollToTop();
    }

    handleChangePageData = (type, isCheckbox) => (event) =>  {
        this.setState({
            pageData: {
                ...this.state.pageData,
                [type]: {
                    ...this.state.pageData?.[type],
                    [event.target.name]: isCheckbox ? event.target.checked : event.target.value
                }

            }
        });
    }

    savePageData = (nextPage) => () => {

        this.handleChangePage(nextPage)();

        if (JSON.stringify(this.state.pageData) !== JSON.stringify(this.props.pagesData?.['HowToWinAndManageResources']?.data))
            this.props.savePageData()('HowToWinAndManageResources', this.state.pageData);
    }

    render() {

        const Page = this.pages[this.state.currentPage] || 'Page1';

        return (
            <Page handleChangePage={this.handleChangePage}
                  handleChangeMainPage={this.props.handleChangePage}
                  handleChangePageData={this.handleChangePageData}
                  incompletePage={!this.state.pageData?.status}
                  pageData={this.state.pageData}
                  savePageStatus={this.props.savePageStatus}
                  savePageData={this.savePageData}/>
        );
    }
}